module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=MD - Moldova.3364dc4b.svg";